var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Edit2 = function Edit2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.793 2.121a3.828 3.828 0 1 1 5.414 5.415l-1 1-9.5 9.5a1 1 0 0 1-.707.292H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l10.5-10.5Zm4 4-.293.293-2.586-2.586.293-.292a1.829 1.829 0 0 1 2.586 2.585ZM6 13.743l8.5-8.5 2.586 2.585-8.5 8.5H6v-2.585Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M5 20a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Edit2;